import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFaroSphereXgLogoWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 89 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "_Library Components",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Grid",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Grid_2",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Library/Sphere XG Logo",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Logo type=Full logo - white",
						children: [
							/* @__PURE__ */ _jsxs("g", {
								id: "Group",
								children: [
									/* @__PURE__ */ _jsx("path", {
										id: "Vector",
										d: "M36.6211 24.8475C35.8889 24.6494 35.2929 24.3978 34.8333 24.0874L35.9316 22.0024C36.4287 22.3209 36.9605 22.5645 37.5217 22.7277C38.0856 22.891 38.6468 22.974 39.2106 22.974C39.7451 22.974 40.1594 22.8964 40.456 22.7411C40.75 22.5859 40.8996 22.3718 40.8996 22.0988C40.8996 21.8633 40.766 21.6813 40.4987 21.5501C40.2315 21.419 39.8173 21.2771 39.2534 21.1272C38.6147 20.9586 38.0856 20.7873 37.6633 20.6134C37.2411 20.4394 36.8776 20.1744 36.573 19.8185C36.2683 19.4625 36.116 18.9915 36.116 18.408C36.116 17.7041 36.3084 17.0859 36.6932 16.5559C37.0781 16.026 37.6259 15.6138 38.3394 15.3221C39.053 15.0304 39.8868 14.8858 40.8435 14.8858C41.5463 14.8858 42.2037 14.9581 42.813 15.1053C43.4224 15.2498 43.9488 15.4613 44.3898 15.7316L43.3769 17.8031C42.9921 17.5596 42.5672 17.3722 42.1022 17.2464C41.6372 17.1207 41.1615 17.0564 40.6725 17.0564C40.1193 17.0564 39.6837 17.1447 39.371 17.3241C39.0556 17.5034 38.9007 17.7336 38.9007 18.0146C38.9007 18.2581 39.0369 18.4455 39.3095 18.5793C39.5821 18.7104 40.0044 18.8523 40.5762 19.0022C41.215 19.1628 41.7414 19.326 42.1583 19.4946C42.5752 19.6632 42.9333 19.9229 43.2353 20.2708C43.5346 20.6187 43.6869 21.0737 43.6869 21.6384C43.6869 22.3343 43.4918 22.9472 43.1017 23.4771C42.7115 24.0071 42.1583 24.4192 41.4421 24.711C40.7232 25.0027 39.8921 25.1472 38.9434 25.1472C38.1283 25.1419 37.3533 25.0428 36.6211 24.8475Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_2",
										d: "M52.1426 17.5118C52.7439 17.9855 53.0432 18.6466 53.0432 19.4923C53.0432 20.1695 52.8722 20.7663 52.5301 21.2828C52.188 21.7994 51.699 22.2009 51.0656 22.4872C50.4323 22.7736 49.6974 22.9181 48.8636 22.9181H47.4285L47.0196 24.9469H44.3044L45.9239 16.7999H49.5958C50.6942 16.7999 51.544 17.0381 52.1426 17.5118ZM49.9566 20.5763C50.1864 20.3702 50.3013 20.0892 50.3013 19.7305C50.3013 19.4308 50.2051 19.2059 50.0127 19.0614C49.8203 18.9169 49.545 18.842 49.1896 18.842H48.2329L47.824 20.8867H48.9918C49.4034 20.8867 49.7267 20.7824 49.9566 20.5763Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_3",
										d: "M63.1208 16.7999L61.488 24.9469H58.7728L59.3768 21.9038H56.7017L56.0977 24.9469H53.3826L55.002 16.7999H57.7172L57.14 19.7305H59.815L60.4056 16.7999H63.1208Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_4",
										d: "M67.2282 18.8018L67.0171 19.8724H70.534L70.1545 21.7619H66.6376L66.3971 22.9449H70.5474L70.1519 24.9469H63.3265L64.946 16.7999H71.6163L71.2208 18.8018H67.2282Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_5",
										d: "M79.6815 21.3658C79.286 21.9011 78.7381 22.2999 78.0353 22.5648L79.4276 24.9469H76.6002L75.419 22.8887H74.66L74.2512 24.9469H71.536L73.1555 16.7999H76.8568C77.9364 16.7999 78.7756 17.0354 79.3768 17.5037C79.9781 17.9748 80.2774 18.6252 80.2774 19.4629C80.2748 20.1962 80.077 20.8305 79.6815 21.3658ZM77.2256 19.0694C77.0224 18.9196 76.7499 18.8446 76.4025 18.8446H75.4591L75.0502 20.8894H76.2047C76.6163 20.8894 76.9423 20.785 77.1748 20.5789C77.4099 20.3729 77.5275 20.0918 77.5275 19.7332C77.5302 19.4415 77.4287 19.2193 77.2256 19.0694Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_6",
										d: "M84.6066 18.8018L84.3955 19.8724H87.9123L87.5329 21.7619H84.016L83.7755 22.9449H87.9257L87.5302 24.9469H80.7102L82.3297 16.7999H89L88.6045 18.8018H84.6066Z",
										fill: "white"
									})
								]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group_2",
								children: [
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_7",
										d: "M1.67621 20.6358C1.66018 21.2915 1.76173 21.9794 1.95147 22.5173C2.36302 23.6816 3.34379 24.4899 4.11879 22.9804C4.78956 21.3504 4.43413 19.1584 3.68319 18.3555C2.77724 17.392 1.72431 18.583 1.67621 20.6358Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_8",
										d: "M3.81975 17.8866C4.00147 19.3613 5.19604 20.3864 6.47345 18.7805C7.49163 17.255 7.26982 15.5608 6.78612 14.8462C5.93629 13.5856 4.27406 14.6 3.8732 16.6233C3.79303 17.0328 3.77165 17.5039 3.81975 17.8866Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_9",
										d: "M4.14007 25.4342C4.64516 27.0615 6.25929 28.3515 7.14118 26.7564C7.75851 25.287 7.09575 23.3466 6.0936 22.5919C4.87231 21.6738 3.74456 22.7899 3.97706 24.6848C4.00378 24.907 4.07059 25.2147 4.14007 25.4342Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_10",
										d: "M2.00744 18.7381C2.64347 17.3999 2.8439 15.1062 2.38425 14.4291C1.95399 13.7948 1.17097 14.8734 0.834252 16.5676C0.641838 17.5418 0.639166 18.524 0.831579 19.0754C0.871665 19.1931 1.25916 20.2021 2.00744 18.7381Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_11",
										d: "M2.86002 26.781C3.01502 25.1859 2.27744 22.935 1.61201 22.4185C0.970635 21.9207 0.636584 23.0474 0.938566 24.6961C1.11227 25.6355 1.4677 26.5723 1.84986 27.0861C1.9808 27.2628 2.64623 28.0764 2.86002 26.781Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_12",
										d: "M6.11522 20.6808C6.1072 20.8334 6.11254 21.0368 6.12591 21.1893C6.31298 23.1699 8.15961 24.3903 9.45038 22.7818C10.2441 21.6818 10.1425 19.8538 9.22857 18.8716C7.99392 17.5414 6.21944 18.5745 6.11522 20.6808Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_13",
										d: "M4.47159 14.7315C5.50047 13.3451 5.66616 11.7419 5.38823 11.1156C4.97935 10.1923 3.70996 11.1076 3.04453 12.8044C2.70246 13.6796 2.71048 14.3086 2.73186 14.5414C2.80401 15.3685 3.4053 16.0001 4.47159 14.7315Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_14",
										d: "M5.90393 30.2979C6.07764 29.0614 5.04074 26.9336 4.02523 26.4385C3.1273 25.9996 2.74782 27.0193 3.26092 28.494C3.41592 28.9356 3.63773 29.3745 3.9023 29.7653C4.59178 30.7743 5.67143 31.521 5.90393 30.2979Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_15",
										d: "M0.000639712 20.6199C0.0140017 21.95 0.187708 23.1946 0.396156 23.4515C0.599258 23.7004 0.700809 22.9912 0.735551 22.7583C0.922619 21.289 0.740896 18.7169 0.425552 18.3208C0.185036 18.0211 -0.0127223 19.097 0.000639712 20.6199Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_16",
										d: "M7.18398 12.8557C7.09045 13.142 7.037 13.4231 7.03165 13.6987C6.99424 15.1948 8.3251 15.9469 9.68268 14.6408C10.5058 13.7817 10.7891 12.39 10.3107 11.5415C9.6132 10.3077 7.77458 11.0812 7.18398 12.8557Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_17",
										d: "M10.6554 30.1526C11.2112 28.9268 10.4496 27.3317 9.39934 26.7215C8.1246 25.9828 7.03961 26.9329 7.40038 28.4772C7.77986 30.1098 9.74408 31.6434 10.6554 30.1526Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_18",
										d: "M1.18469 26.4921C0.933483 26.3743 1.13659 27.2763 1.63098 28.4646C2.14943 29.7118 2.72132 30.6486 2.93244 30.7449C3.11149 30.8252 2.99391 30.3675 2.9458 30.1722C2.54227 28.7563 1.53745 26.658 1.18469 26.4921Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_19",
										d: "M1.36345 14.5955C2.07431 13.1796 2.66491 11.1937 2.53129 10.9181C2.41638 10.6825 1.89258 11.555 1.41155 12.7862C0.97595 13.8996 0.708709 14.9835 0.812933 15.2057C0.919829 15.4278 1.25388 14.8015 1.36345 14.5955Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_20",
										d: "M12.6198 18.4993C13.638 17.2601 13.304 15.9888 12.9432 15.4321C11.933 13.8718 9.76034 14.6292 9.41828 16.6633C9.3969 16.7944 9.38086 16.9684 9.38086 17.1022C9.37819 18.9061 11.1446 19.9874 12.6198 18.4993Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_21",
										d: "M6.30472 9.37603C6.0642 9.80693 5.92257 10.2646 5.91188 10.6286C5.88515 11.4717 6.57998 11.9962 7.76652 10.9364C8.60566 10.1361 9.11876 8.81131 8.86488 8.09938C8.52014 7.13855 7.04498 8.0405 6.30472 9.37603Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_22",
										d: "M12.9961 26.4862C13.9074 25.1748 13.2046 23.7509 12.5472 23.1621C11.2324 21.9818 9.44987 22.8864 9.52202 24.7011C9.5915 26.4273 11.5985 28.084 12.9961 26.4862Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_23",
										d: "M6.83144 32.2648C7.52092 33.3728 9.16177 34.5799 9.43703 33.3621C9.55462 32.1657 8.40548 30.6295 7.4167 30.2575C6.45463 29.8961 6.06179 30.7312 6.63635 31.9115C6.6898 32.0212 6.7673 32.1604 6.83144 32.2648Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_24",
										d: "M5.65288 33.7877C6.1446 34.05 6.00563 33.5281 5.9602 33.3568C5.64486 32.305 4.24987 30.3271 3.59245 30.1772C3.14616 30.0755 3.30918 30.8811 3.93987 31.9008C4.52512 32.8456 5.26003 33.5763 5.65288 33.7877Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_25",
										d: "M2.87902 11.2837C2.89772 11.4389 3.02065 11.8698 3.87582 10.9304C4.88065 9.73406 5.48461 8.22188 5.38573 7.82578C5.27349 7.37346 4.34082 8.17371 3.60591 9.35668C3.05539 10.2479 2.84427 10.9652 2.87902 11.2837Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_26",
										d: "M16.2089 22.4258C17.187 21.2482 16.7273 19.9501 16.1795 19.364C14.9582 18.0552 12.9486 18.8608 12.8203 20.7129C12.8149 20.7744 12.8149 20.8574 12.8149 20.9216C12.8497 22.6854 14.7845 23.8309 16.2089 22.4258Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_27",
										d: "M9.51435 36.0408C9.10547 35.0104 7.5822 33.5384 6.92746 33.541C6.49721 33.5437 6.6629 34.1727 7.28557 34.9194C7.74255 35.4654 8.39996 36.0114 8.92108 36.279C9.44487 36.5493 9.6453 36.469 9.51435 36.0408Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_28",
										d: "M7.24319 7.56071C8.15983 6.79258 8.89207 5.58016 8.82793 5.16264C8.75043 4.66215 7.59862 5.41155 6.8263 6.31618C6.39337 6.82469 6.11277 7.33321 6.07268 7.67312C6.03259 8.03711 6.31052 8.30743 7.24319 7.56071Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_29",
										d: "M11.1042 9.39716C11.0133 9.61662 10.9599 9.83341 10.9465 10.0422C10.869 11.3161 12.2319 11.7497 13.3009 10.7942C14.2416 9.87891 14.1561 8.93414 13.9556 8.51929C13.3811 7.32294 11.6681 8.04289 11.1042 9.39716Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_30",
										d: "M14.2793 33.1767C14.7443 32.2855 14.1617 31.14 13.3253 30.6315C12.1414 29.9115 11.0537 30.6315 11.4145 31.8947C11.7646 33.1286 13.499 34.2955 14.2793 33.1767Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_31",
										d: "M11.4548 7.49106C12.3607 6.71757 12.5558 5.8638 12.465 5.47572C12.2645 4.62194 10.8802 5.25893 10.1614 6.30541C9.9155 6.66137 9.82731 6.94239 9.79524 7.11636C9.64826 7.93802 10.3992 8.2806 11.4548 7.49106Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_32",
										d: "M13.0631 35.982C13.1593 35.1309 12.1331 33.8729 11.1684 33.6588C10.3827 33.4849 10.1021 34.0951 10.5885 34.9141C11.2004 35.9391 12.8092 36.9133 13.0631 35.982Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_33",
										d: "M16.6818 29.8802C17.4248 28.9221 16.9411 27.8569 16.4333 27.3751C15.2655 26.2617 13.491 26.9496 13.6005 28.4698C13.7074 29.9712 15.538 31.0525 16.6818 29.8802Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_34",
										d: "M16.6576 12.0338C15.88 10.6715 13.7875 11.2148 13.4133 12.8742C13.3893 12.9785 13.3706 13.1204 13.3652 13.2274C13.3038 14.6727 14.9072 15.5318 16.2541 14.3489C17.2963 13.2381 16.7245 12.1515 16.6576 12.0338Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_35",
										d: "M4.82423 7.47838C5.45224 6.83604 6.81517 5.2516 6.79646 5.07228C6.69758 5.01607 5.99474 5.66644 5.43353 6.2847C4.83759 6.94042 4.22293 7.74869 4.26836 7.9066C4.33785 7.9414 4.54095 7.7594 4.82423 7.47838Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_36",
										d: "M4.89375 33.6215C4.86168 33.7473 5.38013 34.3736 5.88521 34.9008C6.64952 35.6984 7.45926 36.3648 7.56348 36.3274C7.56883 36.2845 7.51271 36.2016 7.32029 35.9741C6.88202 35.4709 5.09418 33.5466 4.89375 33.6215Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_37",
										d: "M16.9623 24.7255C16.8794 26.3581 18.841 27.2547 20.0061 26.1172C20.8533 25.1885 20.4631 24.2063 20.0997 23.7727C19.0387 22.5094 17.0451 23.117 16.9623 24.7255Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_38",
										d: "M19.9205 18.1042C20.7917 17.1433 20.4176 16.1531 20.0621 15.7168C19.0466 14.4883 17.0878 15.0691 16.8847 16.6589C16.8793 16.7098 16.874 16.7767 16.8713 16.8302C16.8285 18.2005 18.4908 19.3969 19.9205 18.1042Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_39",
										d: "M13.1622 38.2061C12.7934 37.4834 11.4813 36.4798 10.896 36.4744C10.5032 36.4718 10.6395 36.916 11.19 37.4299C11.5588 37.7752 12.0719 38.1151 12.5289 38.3158C12.903 38.4817 13.3172 38.5995 13.1622 38.2061Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_40",
										d: "M10.8588 38.201C10.1346 37.5453 8.65671 36.464 8.34137 36.4667C8.14895 36.4694 8.47231 36.8788 9.19386 37.4222C9.99291 38.0244 10.971 38.5382 11.0592 38.4472C11.0565 38.399 11.0164 38.3509 10.8588 38.201Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_41",
										d: "M11.0028 4.6143C11.9569 3.94519 12.3898 3.2065 12.3978 2.97365C12.4139 2.54543 11.3529 3.05662 10.6207 3.72573C10.2679 4.0469 10.0274 4.37074 9.95793 4.61162C9.85905 4.9542 10.1183 5.1817 11.0028 4.6143Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_42",
										d: "M8.22648 4.60892C9.09769 3.99067 10.1506 3.01645 10.18 2.84784C10.2121 2.66584 9.35424 3.14492 8.622 3.715C7.95657 4.23422 7.56373 4.68386 7.5183 4.85783C7.49157 4.96488 7.54769 5.07194 8.22648 4.60892Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_43",
										d: "M15.1208 6.34345C15.0808 6.44515 15.0407 6.58432 15.03 6.68335C14.9071 7.63883 16.0214 8.0162 16.8633 7.30695C17.6008 6.62179 17.3683 5.95269 17.3122 5.82422C16.9354 4.93833 15.5618 5.26485 15.1208 6.34345Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_44",
										d: "M16.9838 34.0314C16.174 33.5791 15.236 33.9725 15.4952 34.9093C15.7304 35.7524 16.9731 36.5392 17.6038 35.7818C17.9993 35.1609 17.6011 34.3767 16.9838 34.0314Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_45",
										d: "M17.7906 31.9001C17.8253 32.9734 19.1589 33.7254 20.0835 32.8931C20.5779 32.4006 20.5432 31.5977 20.0114 31.1052C19.2123 30.3665 17.7505 30.7171 17.7906 31.9001Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_46",
										d: "M17.5634 9.41321C17.5554 9.45068 17.5474 9.50153 17.5447 9.539C17.4298 10.6497 18.7553 11.3831 19.8296 10.4731C20.308 10.0234 20.3962 9.31954 20.0381 8.80299C19.3726 7.83948 17.8013 8.22756 17.5634 9.41321Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_47",
										d: "M16.3665 38.1155C16.4761 37.6311 15.7839 36.7612 15.0196 36.6194C14.5011 36.523 14.2018 36.8603 14.5947 37.441C15.0276 38.0834 16.1794 38.6936 16.3665 38.1155Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_48",
										d: "M15.0541 4.49664C15.8425 3.88374 15.765 3.27351 15.7623 3.24943C15.6688 2.60709 14.6105 3.00052 14.06 3.73118C13.8836 3.96671 13.8221 4.15138 13.8008 4.26646C13.6965 4.8526 14.3887 4.97839 15.0541 4.49664Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_49",
										d: "M12.072 2.24599C12.6305 1.95961 13.7583 1.23698 13.753 1.12189C13.6728 1.06301 12.9673 1.34939 12.3793 1.68127C11.7968 2.01046 11.46 2.29684 11.428 2.41193C11.4119 2.47884 11.4707 2.54842 12.072 2.24599Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_50",
										d: "M14.5493 39.8467C14.079 39.547 12.5718 38.7199 12.3419 38.7869C12.2297 38.819 12.5103 39.0732 13.0956 39.381C13.7396 39.7209 14.552 40.018 14.7097 39.9993C14.7124 39.9939 14.715 39.9859 14.7177 39.9805C14.6963 39.9457 14.6643 39.9217 14.5493 39.8467Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_51",
										d: "M21.1688 20.7297C21.0512 22.0626 22.6279 23.0314 23.7958 21.9555C24.4238 21.3025 24.3142 20.3978 23.8947 19.8759C23.0235 18.7947 21.2891 19.338 21.1688 20.7297Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_52",
										d: "M21.3102 28.4964C21.2033 29.5536 22.4914 30.319 23.4909 29.4787C23.9746 29.0317 24.0548 28.2957 23.6699 27.8059C22.9671 26.9066 21.4251 27.3589 21.3102 28.4964Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_53",
										d: "M23.5311 13.9155C24.1351 13.2197 23.8091 12.4997 23.5205 12.1839C22.7321 11.3248 21.3104 11.7584 21.2142 12.8851C21.1206 13.9798 22.5611 14.8121 23.5311 13.9155Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_54",
										d: "M14.8487 38.8405C14.6322 38.8699 14.7605 39.1081 15.1373 39.3811C15.4874 39.6354 15.955 39.8441 16.233 39.9218C16.6205 40.0288 16.5296 39.8709 16.4949 39.812C16.1956 39.3972 15.2281 38.787 14.8487 38.8405Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_55",
										d: "M14.6828 2.20588C15.3135 1.83653 15.6716 1.38689 15.685 1.2504C15.7117 1.00684 14.9688 1.30125 14.4477 1.68398C14.1938 1.87132 14.0094 2.0667 13.9559 2.2032C13.8784 2.40928 14.0869 2.52437 14.6828 2.20588Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_56",
										d: "M25.5407 24.7623C25.538 24.7918 25.5327 24.8319 25.5327 24.864C25.5006 25.7125 26.4386 26.2611 27.1896 25.5867C27.5744 25.2039 27.6412 24.6017 27.3472 24.1842C26.8288 23.4482 25.6609 23.8202 25.5407 24.7623Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_57",
										d: "M25.5247 16.6901C25.5247 16.7196 25.5247 16.7624 25.5247 16.7918C25.5647 17.6777 26.5936 18.2585 27.2911 17.5412C27.6519 17.1291 27.6172 16.4573 27.2136 16.0451C26.5909 15.4135 25.5647 15.8042 25.5247 16.6901Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_58",
										d: "M15.899 0.506238C16.1956 0.399182 16.9733 0.0726594 17.0508 0.0111019C17.0508 0.00842544 17.0508 0.00307255 17.0508 0.000396141C16.984 -0.0076331 16.5564 0.107453 16.1769 0.249303C15.7868 0.393829 15.4901 0.549061 15.5035 0.599913C15.5462 0.624001 15.6932 0.578502 15.899 0.506238Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_59",
										d: "M19.8057 4.27161C20.1718 3.91297 20.0142 3.57842 19.958 3.48207C19.6534 2.97623 18.8971 3.22781 18.7368 3.75506C18.7261 3.78986 18.7154 3.83803 18.7127 3.87283C18.6646 4.37599 19.2873 4.68913 19.8057 4.27161Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_60",
										d: "M20.0785 37.0048C19.6269 36.6836 19.0523 36.9352 19.1191 37.425C19.1806 37.8747 19.8166 38.2895 20.2335 37.8854C20.4927 37.5669 20.3484 37.1948 20.0785 37.0048Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_61",
										d: "M18.0555 2.05613C18.4029 1.79384 18.3896 1.53958 18.3842 1.4914C18.3388 1.14615 17.7829 1.32279 17.5157 1.68946C17.4409 1.79116 17.4195 1.87145 17.4115 1.90357C17.3473 2.18459 17.66 2.31574 18.0555 2.05613Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_62",
										d: "M21.5855 34.9143C21.5187 35.4443 22.1574 35.9394 22.7694 35.4523C23.1569 35.0856 23.0366 34.6922 22.919 34.5343C22.5503 34.0445 21.6657 34.2961 21.5855 34.9143Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_63",
										d: "M22.7453 6.9354C23.098 6.51252 22.8014 6.10839 22.7373 6.03077C22.2883 5.4821 21.4331 5.68819 21.393 6.35729C21.3556 6.97287 22.2108 7.44659 22.7453 6.9354Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_64",
										d: "M18.3335 39.0093C18.0502 38.9611 17.9353 39.1458 18.0983 39.3893C18.3014 39.6918 18.8519 39.9701 18.9642 39.6971C19.0363 39.4803 18.7103 39.0735 18.3335 39.0093Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_65",
										d: "M25.1424 31.922C25.137 31.9408 25.1317 31.9649 25.129 31.9836C25.0488 32.5001 25.5833 32.832 26.1044 32.4306C26.4705 32.0933 26.4037 31.7267 26.3155 31.5795C26.0724 31.1619 25.292 31.3091 25.1424 31.922Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_66",
										d: "M26.2917 9.95902C26.4921 9.70476 26.412 9.27921 26.1126 9.0303C25.6583 8.65025 25.0597 8.89113 25.0945 9.43979C25.1319 10.0018 25.8775 10.4194 26.2917 9.95902Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_67",
										d: "M17.8363 0.43977C18.0902 0.319331 18.2879 0.15607 18.3066 0.0998654C18.3387 0.0115438 18.0127 0.1186 17.7775 0.257774C17.6465 0.332713 17.5584 0.407653 17.5396 0.458505C17.5183 0.512033 17.5958 0.54415 17.8363 0.43977Z",
										fill: "white"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Vector_68",
										d: "M30.6476 20.4294C30.3616 20.0574 29.8298 20.2688 29.7817 20.772C29.7791 20.8068 29.7791 20.8523 29.7791 20.8844C29.8111 21.3795 30.3242 21.6017 30.6262 21.2537C30.8667 20.9406 30.7705 20.59 30.6476 20.4294Z",
										fill: "white"
									})
								]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group_3",
								children: [/* @__PURE__ */ _jsx("path", {
									id: "Vector_69",
									d: "M39.6249 30.3768L41.1749 33.2084H39.1225L38.3769 31.7043L37.0914 33.2084H34.8333L37.5538 30.2778L36.092 27.5237H38.115L38.8419 28.969L40.1086 27.5237H42.2599L39.6249 30.3768Z",
									fill: "white"
								}), /* @__PURE__ */ _jsx("path", {
									id: "Vector_70",
									d: "M45.8412 30.2669H47.5194L46.9288 33.2083H45.7396L45.8091 32.8443C45.4109 33.1708 44.9085 33.3368 44.3072 33.3368C43.8369 33.3368 43.4039 33.2324 43.0164 33.0263C42.6263 32.8202 42.3189 32.5258 42.0891 32.1457C41.8593 31.7657 41.7444 31.3241 41.7444 30.8182C41.7444 30.1572 41.8994 29.5657 42.2094 29.0438C42.5194 28.5219 42.9577 28.1177 43.5189 27.8287C44.0801 27.5396 44.7241 27.3951 45.443 27.3951C46.0176 27.3951 46.5307 27.4888 46.9796 27.6761C47.4286 27.8635 47.784 28.1338 48.0459 28.4871L46.6803 29.5389C46.5039 29.3087 46.3062 29.1455 46.087 29.0465C45.8679 28.9474 45.622 28.8993 45.3468 28.8993C44.8364 28.8993 44.4275 29.0652 44.1202 29.3997C43.8128 29.7343 43.6578 30.1598 43.6578 30.6791C43.6578 31.0324 43.7567 31.3161 43.9518 31.5302C44.1495 31.7443 44.4168 31.8487 44.7562 31.8487C45.0368 31.8487 45.3067 31.7737 45.5606 31.6212L45.8412 30.2669Z",
									fill: "white"
								})]
							})
						]
					})
				})
			})
		})
	})
});
export default SvgFaroSphereXgLogoWhite;
